// directives/vLoading.js
import { createApp } from 'vue'
import LoadingSpinner from '../components/common/LoadingSpinner.vue'

export const vLoading = {
    mounted(el, binding) {
        const app = createApp(LoadingSpinner, { overlay: binding.modifiers.overlay })
        const instance = app.mount(document.createElement('div'))
        el.instance = instance
        if (binding.value) el.appendChild(instance.$el)
    },
    updated(el, binding) {
        if (binding.oldValue !== binding.value) {
            if (binding.value) {
                el.appendChild(el.instance.$el)
            } else {
                el.removeChild(el.instance.$el)
            }
        }
    }
}